import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Switch from "@mui/material/Switch";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import SubscriberGroupBoxPlot from "./SubscriberGroupBoxPlot";
import PercentageWarning from "../../Subscriber&Groups/PercentageWarning";
import { thresholdKeyMap } from "../../Subscriber&Groups/utils";

const Wrapper = styled.div`
  margin: 30px 20px 0 20px;
`;

const WrapperTotalColorize = styled.div`
  display: flex;
  padding: 10px 0 0px 0;
  justify-content: space-between;
`;

const WrapperSwitch = styled.div`
  display: flex;
  align-items: center;
  color: var(--Text-Primary);
  .sw-input.MuiSwitch-root {
    & .Mui-checked {
      color: var(--switch-checked-green);
    }

    & .Mui-checked + .MuiSwitch-track {
      background-color: var(--switch-checked-light-green);
    }
  }
`;

const TotalSubscribers = styled.h4`
  font-size: 16px !important;
  font-weight: 100 !important;
  color: var(--text-primary) !important;
  margin-right: 20px;
`;

const WrapperRightMenu = styled.div`
  display: flex;
  align-items: center;
`;

const WrapperCollapse = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
  color: var(--Text-Primary);
  .material-icons {
    color: var(--text-primary) !important;
    margin-left: 5px;
  }
`;

const CenteredMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 100%;
  min-height: 25px;
  margin-bottom: 40px;
  color: var(--Text-Primary);
`;

const NoEnoughtData = () => (
  <CenteredMessage>Not enough data to display box plots.</CenteredMessage>
);

const BOXPLOT_METRICS_ORDER_MAP = {
  "MEAN-Mbps": 0,
  "SUBS-ACTIVE": 1,
  "RTT-80%-ms": 2,
  "RTT-MED-ms": 3,
  "RTT-MIN-ms": 4,
  RTX: 5,
  CONGEST: 6,
};

const specValues = new Set(["RTT-MED-ms", "RTT-MIN-ms", "RTT-P80-ms"]);

const Statistics = ({
  data,
  thresholds,
  setThresholds,
  colorize,
  setColorize,
  metricsQuantileData
}) => {
  const [showBoxplots, setShowBoxplots] = useState(true);
  const statisticsMetrics = Object.entries(data)
    .filter(([key, value]) => {
      return key !== "totalGroups" && key !== "newRows" && key !== "names" && key !== 'rows';
    })
    .sort(
      (a, b) =>
        BOXPLOT_METRICS_ORDER_MAP[a[0]] - BOXPLOT_METRICS_ORDER_MAP[b[0]]
    );

  const handleUpdateThresholds = (metric, value) => {
    const specValue = specValues.has(metric) && value !== "auto" ? value / 1000 : value;
    const cmd = `configure\npkteng\nmetrics threshold ${thresholdKeyMap[metric]} ${specValue}\ncommit\n`;
    const metricKey = metric === "RTT-P80-ms" ? "RTT-80%-ms" : metric;
    ifCl
      .run(cmd, true)
      .then(() => setThresholds({ ...thresholds, [metricKey]: value }))
      .catch((error) => showModalError("Error:", error));
  };

  return (
    <div className="card">
    <Wrapper>
      <WrapperTotalColorize>
        <TotalSubscribers className="total-subscribers-label">
          {data.totalGroups} Groups
        </TotalSubscribers>
        <WrapperRightMenu>
        <WrapperSwitch>
          <div>
            {!colorize
              ? "Colorize: by warning threshold"
              : "Colorize: by quartiles"}
          </div>
          <Switch
            className="sw-input"
            checked={colorize}
            onChange={() => setColorize(!colorize)}
          />
        </WrapperSwitch>
        <WrapperCollapse onClick={() => setShowBoxplots(!showBoxplots)} >{showBoxplots ? "Hide Boxplots" : "Show Boxplots"}<i className="material-icons icon-collapse-row">{showBoxplots ? "expand_less" : "expand_more"}</i></WrapperCollapse>
        </WrapperRightMenu>
      </WrapperTotalColorize>
      <PercentageWarning
          meanThreshold={thresholds["MEAN-Mbps"]}
          percentWarning={thresholds["PERCENT-WARNING"]}
          updateThresholds={(metric, value) =>
            handleUpdateThresholds(metric, value)
          }
        />
      {!showBoxplots ? null : data.totalGroups < 2 ? (
        <NoEnoughtData />
      ) : (
        <ColumnsGrid
          columns={statisticsMetrics.length}
          minWidth="3.5cm"
          gap={"1em"}
          className="box-plot-container"
          rowGap="0"
        >
          {statisticsMetrics.map(([key, values]) => {
            return (
              <SubscriberGroupBoxPlot
                metric={key}
                data={values}
                threshold={thresholds[key]}
                quantileData={metricsQuantileData[key]}
                updateThresholds={handleUpdateThresholds}
                colorize={colorize}
                key={`box-plot-${key}`}
              />
            );
          })}
        </ColumnsGrid>
      )}
    </Wrapper>
    </div>
  );
};

export default Statistics;
